var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContentFeed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 4 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6881 4.16992H3.02112C1.35526 4.16992 0 5.55028 0 7.24686V17.093C0 18.7896 1.35526 20.1699 3.02112 20.1699H12.6881C14.3532 20.1699 15.7091 18.7896 15.7091 17.093V7.24686C15.7091 5.55028 14.3532 4.16992 12.6881 4.16992ZM14.5007 17.093C14.5007 18.1115 13.6872 18.9392 12.6881 18.9392H3.02112C2.0211 18.9392 1.20862 18.1115 1.20862 17.093V7.24686C1.20862 6.22896 2.0211 5.40067 3.02112 5.40067H12.6881C13.6872 5.40067 14.5007 6.22896 14.5007 7.24686V17.093Z",
    fill: "url(#paint0_linear_49_23)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.823 10.4777V9.55469H10.4426V5.09302H9.53625V9.55469H6.21313V5.09302H5.307V9.55469H0.926514V10.4777H5.307V13.8623H0.926514V14.7852H5.307V19.2468H6.21313V14.7852H9.53625V19.2468H10.4426V14.7852H14.823V13.8623H10.4426V10.4777H14.823ZM9.53625 13.8623H6.21313V10.4777H9.53625V13.8623Z",
    fill: "url(#paint1_linear_49_23)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_49_23",
    x1: 0.50681,
    y1: 3.91186,
    x2: 16.015,
    y2: 20.6628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6CE65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489999,
    stopColor: "#CA2C69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#971994"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_49_23",
    x1: 1.37484,
    y1: 4.86473,
    x2: 15.0935,
    y2: 19.6828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6CE65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489999,
    stopColor: "#CA2C69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#971994"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentFeed);
export default __webpack_public_path__ + "static/media/content-feed.a9aec45aacb4c359a0844069e75e2dd4.svg";
export { ForwardRef as ReactComponent };